import React, { useEffect, useState } from 'react';
import { string, func } from 'prop-types';
import PlayIcon from 'assets/images/icons/play.svg';
import styles from './Thumb.module.scss';

const Thumb = ({
  type,
  imageUrl,
  videoCoverImage,
  youtubeVideoId,
  onClick,
}) => {
  const [thumbUrl, setThumbUrl] = useState(null);
  const [isVideo, setIsVideo] = useState(false);

  useEffect(() => {
    if (type === 'video') {
      setIsVideo(true);
      if (videoCoverImage === '') {
        if (youtubeVideoId !== '') {
          setThumbUrl(`http://i3.ytimg.com/vi/${youtubeVideoId}/hqdefault.jpg`);
        } else {
          setThumbUrl(videoCoverImage);
        }
      } else {
        setThumbUrl(videoCoverImage);
      }
    } else {
      setIsVideo(false);
      setThumbUrl(imageUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <button type="button" className={styles.wrapper} onClick={onClick}>
      <img src={thumbUrl} alt="img" />
      {isVideo && (
        <div className={styles.playSymbol}>
          <PlayIcon />
        </div>
      )}
    </button>
  );
};

Thumb.propTypes = {
  type: string.isRequired,
  imageUrl: string.isRequired,
  videoCoverImage: string.isRequired,
  youtubeVideoId: string.isRequired,
  onClick: func.isRequired,
};

export default Thumb;
